import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { Search, PauseCircle, HeartHandshake } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    icon: <Search className="w-8 h-8" data-id="element-119" />,
    title: 'Identifica',
    desc: 'Reconoce la señal física de tu cuerpo antes del grito.'
  }, {
    number: '2',
    icon: <PauseCircle className="w-8 h-8" data-id="element-120" />,
    title: 'Interrumpe',
    desc: 'Aplica el Método de Reinicio sensorial para enfriar tu sistema.'
  }, {
    number: '3',
    icon: <HeartHandshake className="w-8 h-8" data-id="element-121" />,
    title: 'Repara',
    desc: 'Usa los guiones tácticos para reconectar con tus hijos desde la calma.'
  }];
  return <AnimatedSection className="bg-cream-dark/20" data-id="element-122">
      <div className="max-w-5xl mx-auto" data-id="element-123">
        <div className="text-center mb-16" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-125">
            Cómo funciona el método
          </h2>
          <p className="text-lg text-charcoal-light" data-id="element-126">
            Un proceso simple de 3 pasos diseñado para cerebros agotados.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-127">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-20 right-20 h-0.5 bg-mint-dark/20 -z-10" data-id="element-128" />

          {steps.map((step, index) => <div key={index} className="relative flex flex-col items-center text-center group" data-id="element-129">
              <div className="w-24 h-24 bg-white rounded-full shadow-md border-4 border-mint-light flex items-center justify-center text-mint-dark mb-6 relative z-10 group-hover:scale-105 transition-transform duration-300 group-hover:border-mint" data-id="element-130">
                {step.icon}
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-gold text-white rounded-full flex items-center justify-center font-bold text-sm shadow-sm" data-id="element-131">
                  {step.number}
                </div>
              </div>
              <h3 className="text-2xl font-bold text-charcoal mb-3" data-id="element-132">
                {step.title}
              </h3>
              <p className="text-charcoal-light text-lg px-4" data-id="element-133">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </AnimatedSection>;
}